//
import L from 'leaflet';

import markericonblue from './marker-icon-2x-blue.png';
import markericongold from './marker-icon-2x-gold.png';
import markericonred from './marker-icon-2x-red.png';
import markericongreen from './marker-icon-2x-green.png';
import markericonorange from './marker-icon-2x-orange.png';
import markericonyellow from './marker-icon-2x-yellow.png';
import markericonviolet from './marker-icon-2x-violet.png';
import markericongrey from './marker-icon-2x-grey.png';
import markericonblack from './marker-icon-2x-black.png';
//import markericon from '.';
import markershadow from './marker-shadow.png';

export const blueIcon = new L.Icon({
	iconUrl: markericonblue,
	shadowUrl: markershadow,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});

export const goldIcon = new L.Icon({
	iconUrl: markericongold,
	shadowUrl: markershadow,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});

export const redIcon = new L.Icon({
	iconUrl: markericonred,
	shadowUrl: markershadow,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});

export const greenIcon = new L.Icon({
	iconUrl: markericongreen,
	shadowUrl: markershadow,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});

export const orangeIcon = new L.Icon({
	iconUrl: markericonorange,
	shadowUrl: markershadow,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});

export const yellowIcon = new L.Icon({
	iconUrl: markericonyellow,
	shadowUrl: markershadow,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});

export const violetIcon = new L.Icon({
	iconUrl: markericonviolet,
	shadowUrl: markershadow,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});

export const greyIcon = new L.Icon({
	iconUrl: markericongrey,
	shadowUrl: markershadow,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});

export const blackIcon = new L.Icon({
	iconUrl: markericonblack,
	shadowUrl: markershadow,
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});
